import { RootState } from '@store/store.interface';

const getState = (state: RootState) => state.riskSupplementCategories;
export const highRiskSupplementCategoriesSelector = (state: RootState) => getState(state).data;
export const highRiskSupplementCategoriesIsLoadingSelector = (state: RootState) =>
  getState(state).isLoading;
export const highRiskSupplementCategoriesIsReadySelector = (state: RootState) =>
  getState(state).isReady;
export const highRiskSupplementCategoriesErrorSelector = (state: RootState) =>
  getState(state).error;
